// Import des libs
import * as bootstrap from 'bootstrap';
import * as Popper from '@popperjs/core';
import jQuery from 'jquery';
import Swal from 'sweetalert2';
import * as toastr from 'toastr';

// Import du Kernel
import DataStorage from '../../../common/utils/DataStorage';
import Kernel from '../../../common/utils/Kernel';

// Import de HegydCore
// import HegydCore from '../../../common/utils/HegydCore';

// Maj des composants du panier
import updateCartViews from './utils/updateCartViews';

// RGPD
import '../../../common/vendor/hegyd/rgpd/js/cookies';
import EssentialsCards from "./components/Product/EssentialsCards";

// Déclaration de mes variables partagés

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
(window as any).Popper = Popper;

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
(window as any).bootstrap = bootstrap;

// (requis par toastr -_-")
(window as any).jQuery = jQuery;
(window as any).$ = jQuery;

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
(window as any).toastr = toastr;

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
(window as any).Swal = Swal;
(window as any).swal = (window as any).Swal;

// Select2 - Select2 is a jQuery based replacement for select boxes: https://select2.org/
require('select2');

/** A storage solution aimed at replacing jQuerys data function.
 * Implementation Note: Elements are stored in a (WeakMap)[https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap].
 * This makes sure the data is garbage collected when the node is removed.
 */
(window as any).dataStorage = DataStorage;

// Kernel permettant de monter les componants data-mount
(window as any).Kernel = Kernel;

// Import de helpers ??
// (window as any).HegydCore = HegydCore;

// Import du helper permettant de mettre à jour des template lors de la maj du panier
(window as any).updateCartViews = updateCartViews;

// Components
Kernel.registerComponent('Addresses', require('./components/Addresses').default);
Kernel.registerComponent('Appointment', require('./components/Myspace/Appointment').default);
Kernel.registerComponent('CartAddresses', require('./components/CartAddresses').default);
Kernel.registerComponent('DesktopNav', require('./components/Nav/DesktopNav').default);
Kernel.registerComponent('ForceShowSubMenu', require('./components/ForceShowSubMenu').default);
Kernel.registerComponent('Login', require('./components/Auth/Login').default);
Kernel.registerComponent('Header', require('./components/Layout/Header').default);
Kernel.registerComponent('Favorite', require('./components/Product/Favorite').default);
Kernel.registerComponent('ProductCard', require('./components/Product/ProductCard').default);
Kernel.registerComponent('ProductFilter', require('./components/Product/ProductFilter').default);
Kernel.registerComponent('ProductSearch', require('./components/Product/ProductSearch').default);
Kernel.registerComponent('Product', require('./components/Product/Product').default);
Kernel.registerComponent('PromoBar', require('./components/PromoBar').default);
Kernel.registerComponent('Quantity', require('./components/Product/Quantity').default);
Kernel.registerComponent('SearchTable', require('./components/searchTable').default);
Kernel.registerComponent('SlotTime', require('./components/SlotTime').default);
Kernel.registerComponent('StoreLocator', require('./components/StoreLocator').default);
Kernel.registerComponent('ZipCitySelector', require('./components/ZipCitySelector').default);
Kernel.registerComponent('ClampText', require('./components/ClampText').default);
Kernel.registerComponent('AjaxDelete', require('./../../../common/js/AjaxDelete').default);

 customElements.define('essentials-cards', EssentialsCards);
// Components
document.addEventListener('DOMContentLoaded', () => {
    const body = document.querySelector('body');
    if (body) {
        Kernel.mountComponents(body);
    }
});


// Watch page scroll

window.addEventListener('scroll', (e) => {
    let $bodyWrapper = document.querySelector('div.categories-filters');
    if($bodyWrapper)
    {
        if (window.scrollY > 168) {
            $bodyWrapper.classList.add("filters-fixed");
        } else {
            $bodyWrapper.classList.remove("filters-fixed");
        }
    }
})

